import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _jsx from "@babel/runtime/helpers/jsx";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toArray from "@babel/runtime/helpers/toArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo, useState, useCallback, useMemo, useRef } from 'react';
import { useIntl } from 'react-intl';
import BankCardCompanyInfo from 'components/BankCardCompanyInfo';
import DropdownButton from 'components/DropdownButton';
import BankCardItem from 'components/BankCardItem';
import { SCROLL_INTO_VIEW } from 'constants/index';
import { BankCardListWrapper, OtherCardsWrapper, ListWrapper, CompanyItem, MoreCardsButton } from './styles';
import { jsx as _jsx2 } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function BankCardList(_ref) {
  var company = _ref.company;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var ref = useRef();

  var _company$products = _toArray(company.products),
      card = _company$products[0],
      otherCards = _company$products.slice(1);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpenOtherCards = _useState2[0],
      setIsOpenOtherCards = _useState2[1];

  var handleShowOtherCards = useCallback(function () {
    setIsOpenOtherCards(!isOpenOtherCards);

    if (isOpenOtherCards) {
      ref.current.scrollIntoView({
        block: SCROLL_INTO_VIEW.start,
        behavior: SCROLL_INTO_VIEW.smooth
      });
    }
  }, [isOpenOtherCards]);
  var showOtherCards = useMemo(function () {
    return !!otherCards.length && /*#__PURE__*/_jsx(OtherCardsWrapper, {
      isOpenOtherCards: isOpenOtherCards
    }, void 0, otherCards.map(function (_card) {
      return /*#__PURE__*/_jsx(ListWrapper, {}, _card.id, /*#__PURE__*/_jsx(BankCardItem, {
        card: _card
      }));
    }));
  }, [otherCards]);
  return /*#__PURE__*/_jsx(BankCardListWrapper, {}, void 0, /*#__PURE__*/_jsxs(CompanyItem, {
    ref: ref,
    children: [/*#__PURE__*/_jsx(ListWrapper, {}, void 0, /*#__PURE__*/_jsx2(BankCardCompanyInfo, _objectSpread({}, company)), /*#__PURE__*/_jsx(BankCardItem, {
      card: card
    })), showOtherCards]
  }), !!otherCards.length && /*#__PURE__*/_jsx(MoreCardsButton, {}, void 0, /*#__PURE__*/_jsx(DropdownButton, {
    showMoreInfo: isOpenOtherCards,
    handleShowInfo: handleShowOtherCards
  }, void 0, formatMessage({
    id: 'BankCardList.moreCardsButton'
  }, {
    count: otherCards.length
  }))));
}

export default /*#__PURE__*/memo(BankCardList);